import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "faeebZ5WGVHbb4XRpZw7hlX", "FitContent", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, view, size, Widget, UITransform } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
/**
 * 防止在内容节点上
 */

var FitContent = (_dec = menu("fit/fitContent"), _dec2 = property({
  tooltip: "屏幕尺寸系数"
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FitContent, _Component);

  function FitContent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "rate", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = FitContent.prototype;

  _proto.onLoad = function onLoad() {
    /**showAll 适配时 的缩放 */
    var canvasSize = view.getCanvasSize();
    var designSize = size(750, 1334);
    var scaleForShowAll = Math.min(canvasSize.width / designSize.width, canvasSize.height / designSize.height);
    /**showAll 模式下 的实际展示宽高 */

    var realSize = size(designSize.width * scaleForShowAll, designSize.height * scaleForShowAll);
    /**showAll模式下， 将画布拉满全屏的最小缩放 */

    var scale_w = canvasSize.width / realSize.width;
    var scale_h = canvasSize.height / realSize.height;
    /**重置宽高 */

    var uiTF = this.node.getComponent(UITransform);
    uiTF.setContentSize(size(uiTF.width *= scale_w, uiTF.height * scale_h));
    var allWidgets = this.node.getComponentsInChildren(Widget);

    for (var i = 0; i < allWidgets.length; i++) {
      allWidgets[i].updateAlignment();
    }
  };

  _proto.start = function start() {} // update (dt) {}
  ;

  return FitContent;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "rate", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
})), _class2)) || _class) || _class);
export { FitContent as default };

_cclegacy._RF.pop();